import { render, staticRenderFns } from "./NoMealPersons.vue?vue&type=template&id=173f5e42&scoped=true&"
import script from "./NoMealPersons.vue?vue&type=script&lang=js&"
export * from "./NoMealPersons.vue?vue&type=script&lang=js&"
import style0 from "./NoMealPersons.vue?vue&type=style&index=0&id=173f5e42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173f5e42",
  null
  
)

export default component.exports